module.exports = __webpack_public_path__ + "img/service20.38bc6043.png";